import { baseConfig } from './__base'
import TempusConfig from './_tempus'
const configMap = {
  tempus: TempusConfig
}

const customConfig = configMap[process.env.REACT_APP_THEME] || {}
export default { ...baseConfig, ...customConfig }
